import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { ThemeProps } from '@lucid/theme';

export interface NavbarItemProps {
  theme?: ThemeProps['theme'];
}

const NavbarItem = styled.li<NavbarItemProps>(({ theme }) => ({
  label: 'navbarItem',
  flex: '0 1 auto',
  alignSelf: 'flex-start',
  listStyle: 'none',
  margin: `auto ${theme.navbar.itemSpacing}`,
  [`@media (max-width: ${theme.navbar.collapseAt})`]: {
    margin: 0,
    borderTop: `1px solid ${theme.navbar.borderColor}`,
    padding: '1rem 2rem',
    width: '100%',
    'button, a': {
      padding: theme.navbar.dropdown.mobilePadding
    },
    '& > [data-link-as-button="true"]': {
      display: 'flex',
      justifyContent: 'center'
    }
  }
}));

export default withTheme(NavbarItem);
